export default __webpack_public_path__ + "static/media/TimeBanner.4c0ae0d2.png";